var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6797 4.13242V2.06189C17.6797 1.88242 17.4735 1.78332 17.3342 1.89314L5.25919 11.3244C5.1566 11.4042 5.07358 11.5063 5.01648 11.6231C4.95937 11.7398 4.92969 11.8681 4.92969 11.998C4.92969 12.128 4.95937 12.2563 5.01648 12.373C5.07358 12.4898 5.1566 12.5919 5.25919 12.6717L17.3342 22.103C17.4762 22.2128 17.6797 22.1137 17.6797 21.9342V19.8637C17.6797 19.7324 17.6181 19.6065 17.5163 19.5262L7.87348 11.9994L17.5163 4.46992C17.6181 4.38957 17.6797 4.26367 17.6797 4.13242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.d46d008d7934b504525eac4ade7d95d1.svg";
export { ForwardRef as ReactComponent };